document.addEventListener("DOMContentLoaded", () => {
  const quizContainer = document.getElementById("quiz-container");
  const stepEl = document.getElementById("quiz-step");
  const quizUrl = quizContainer.dataset.quizJson;

  let quizData = {};
  let selectedCategories = [];
  let selectedSubcategories = [];
  let currentQuestions = [];
  let currentQuestionIndex = 0;
  let answers = [];

  async function initQuiz() {
    try {
      const res = await fetch(quizUrl);
      quizData = await res.json();
      renderCategorySelection();
    } catch (e) {
      console.error("Error loading quiz data:", e);
      stepEl.innerHTML = "<p>Quiz data could not be loaded.</p>";
    }
  }

  // STEP 1: Choose Main Categories
  function renderCategorySelection() {
    stepEl.innerHTML = `
      <h2>Select up to 2 main categories</h2>
      <div class="quiz-options" id="main-categories"></div>
      <div class="quiz-navigation"><button id="next-btn" disabled>Next</button></div>
    `;

    const container = document.getElementById("main-categories");
    const nextBtn = document.getElementById("next-btn");

    quizData.categories.forEach((cat) => {
      const btn = document.createElement("button");
      btn.textContent = cat.title;
      btn.dataset.id = cat.id;
      btn.addEventListener("click", () => {
        toggleSelect(btn, selectedCategories, 2);
        nextBtn.disabled = selectedCategories.length === 0;
      });
      container.appendChild(btn);
    });

    nextBtn.addEventListener("click", () => {
      if (selectedCategories.includes("digestion")) {
        renderSubcategorySelection();
      } else {
        prepareQuestions();
      }
    });
  }

  // STEP 2: If digestion selected, choose subcategories
  function renderSubcategorySelection() {
    stepEl.innerHTML = `
      <h2>Select up to 2 digestive concerns</h2>
      <div class="quiz-options" id="subcategories"></div>
      <div class="quiz-navigation">
        <button id="back-btn">Back</button>
        <button id="next-btn" disabled>Next</button>
      </div>
    `;

    const container = document.getElementById("subcategories");
    const nextBtn = document.getElementById("next-btn");
    const backBtn = document.getElementById("back-btn");

    const digestion = quizData.categories.find((c) => c.id === "digestion");

    digestion.subcategories.forEach((sub) => {
      const btn = document.createElement("button");
      btn.textContent = sub.title;
      btn.dataset.id = sub.id;
      btn.addEventListener("click", () => {
        toggleSelect(btn, selectedSubcategories, 2);
        nextBtn.disabled = selectedSubcategories.length === 0;
      });
      container.appendChild(btn);
    });

    backBtn.addEventListener("click", () => renderCategorySelection());
    nextBtn.addEventListener("click", prepareQuestions);
  }

  // STEP 3: Prepare questions from selected categories
  function prepareQuestions() {
    currentQuestions = [];

    selectedCategories.forEach((catId) => {
      const cat = quizData.categories.find((c) => c.id === catId);

      if (catId === "digestion") {
        selectedSubcategories.forEach((subId) => {
          const sub = cat.subcategories.find((s) => s.id === subId);
          currentQuestions.push(...sub.questions.map((q) => ({
            ...q,
            category: sub.title
          })));
        });
      } else {
        currentQuestions.push(...cat.questions.map((q) => ({
          ...q,
          category: cat.title
        })));
      }
    });

    currentQuestionIndex = 0;
    renderQuestion();
  }

  // STEP 4: Render individual questions
  function renderQuestion() {
    const q = currentQuestions[currentQuestionIndex];
    stepEl.innerHTML = `
      <h3>${q.text}</h3>
      <div class="quiz-options" id="question-options"></div>
      <div class="quiz-navigation">
        <button id="prev-btn" ${currentQuestionIndex === 0 ? "disabled" : ""}>Back</button>
        <button id="next-btn">${currentQuestionIndex === currentQuestions.length - 1 ? "Finish" : "Next"}</button>
      </div>
    `;

    const container = document.getElementById("question-options");

    q.options.forEach((opt) => {
      const btn = document.createElement("button");
      btn.textContent = opt;
      btn.addEventListener("click", () => {
        selectAnswer(q.text, opt);
        highlightSelection(container, btn);
      });
      container.appendChild(btn);
    });

    document.getElementById("next-btn").addEventListener("click", nextQuestion);
    document.getElementById("prev-btn").addEventListener("click", prevQuestion);
  }

  function selectAnswer(questionText, answer) {
    const existing = answers.find((a) => a.question === questionText);
    if (existing) existing.answer = answer;
    else answers.push({ question: questionText, answer });
  }

  function nextQuestion() {
    if (currentQuestionIndex < currentQuestions.length - 1) {
      currentQuestionIndex++;
      renderQuestion();
    } else {
      renderResults();
    }
  }

  function prevQuestion() {
    if (currentQuestionIndex > 0) {
      currentQuestionIndex--;
      renderQuestion();
    }
  }

  // STEP 5: Results
  function renderResults() {
  // Save results to localStorage
  localStorage.setItem("doshaQuizResults", JSON.stringify(answers));

  // Redirect to results page
  window.location.href = "/pages/dosha-skin-results";
}


  // Helpers
  function toggleSelect(btn, arr, limit) {
    const id = btn.dataset.id;
    if (arr.includes(id)) {
      arr.splice(arr.indexOf(id), 1);
      btn.classList.remove("active");
    } else if (arr.length < limit) {
      arr.push(id);
      btn.classList.add("active");
    }
  }

  function highlightSelection(container, selectedBtn) {
    container.querySelectorAll("button").forEach((b) => b.classList.remove("active"));
    selectedBtn.classList.add("active");
  }

  initQuiz();
});
